import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import OfflineIndicator from '../components/OfflineIndicator';
import './MainLayout.css';

const MainLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname.startsWith(path);

  // Navigation items per the documentation:
  // Dashboard: all roles
  // Customers: all roles
  // Services: all roles
  // Payments: manager+
  // Inventory: manager+
  // Reports: all roles (page handles sub-permissions internally)
  // Users: admin+
  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: 'D', roles: ['superadmin', 'admin', 'manager', 'technician'] },
    { path: '/customers', label: 'Customers', icon: 'C', roles: ['superadmin', 'admin', 'manager', 'technician'] },
    { path: '/services', label: 'Services', icon: 'S', roles: ['superadmin', 'admin', 'manager', 'technician'] },
    { path: '/payments', label: 'Payments', icon: 'P', roles: ['superadmin', 'admin', 'manager'] },
    { path: '/inventory', label: 'Inventory', icon: 'I', roles: ['superadmin', 'admin', 'manager'] },
    { path: '/reports', label: 'Reports', icon: 'R', roles: ['superadmin', 'admin', 'manager', 'technician'] },
    { path: '/users', label: 'Users', icon: 'U', roles: ['superadmin', 'admin'] },
  ];

  const filteredMenuItems = menuItems.filter(item =>
    item.roles.includes(user?.role)
  );

  return (
    <div className="main-layout">
      <header className="app-header">
        <div className="header-left">
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            &#9776;
          </button>
          <h1 className="app-title">Pest Patrol</h1>
        </div>
        <div className="header-right">
          <span className="user-info">
            {user?.full_name || user?.username} ({user?.role})
          </span>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </header>

      <OfflineIndicator />

      <div className="app-body">
        <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
          <nav className="sidebar-nav">
            {filteredMenuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
              >
                <span className="nav-icon">{item.icon}</span>
                {sidebarOpen && <span className="nav-label">{item.label}</span>}
              </Link>
            ))}
          </nav>
        </aside>

        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
